import React, { useState, useEffect, useContext, useMemo } from 'react';
import { debounce } from 'lodash';
import APIService from '../../shared/services/api';
import Notify from '../../shared/notify';
import { AuthContext } from '@shared/context/AuthContext';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useLocalStorage } from '@shared/auth/useLocalStorage';
import ViewModel from './viewModel';
import OtherDemandView from './otherDemandViewModel';
import ReactStars from 'react-rating-stars-component';
import {
    DateFormatPicker,
    TextTruncate,
    actionsPermissionValidator,
    checkUrlString,
    ActionValues,
} from '@utils/static/commonUtils';

export function Bids() {
    const { setLoader } = useContext(AuthContext);
    const [demandType, setDemandType] = useState('');
    const [Bids, setBids] = useState<any>([]);
    const { getStorageItem }: any = useLocalStorage();
    const user = getStorageItem('user') ? JSON.parse(getStorageItem('user')) : false;
    const params: any = useParams();
    const navigate = useNavigate();
    const [id, setId] = useState('');
    const [demandStatus, setDemandStatus] = useState('');
    // const [recordCount, setRecordCount] = useState(0);
    const [cutOffTime, setCutOffTime] = useState('');
    const [showHideModel, setShowHideModel] = useState(false);
    const [formData, setFormData] = useState<any>({});
    const [deleteShow, setDeleteShow] = useState(false);
    const [selectedOption, setSelectedOption] = useState<any>([]);
    const [confirmModal, setConfirmModal] = useState(false);
    const [bidWinner, setBidWinner] = useState(false);
    const [activeDemand, setActiveDemand] = useState<any>(false);
    const [search, setSearch] = useState('');
    const [resetRadio, setresetRadio] = useState(null);
    const [demandData, setDemandData] = useState<any>([]);
    const [demandModel, setDemandModel] = useState(false);
    const [otherDemandModel, setOtherDemandModel] = useState(false);
    const [lowestBid, setLowestBid] = useState(0);
    const [isBidViewBlocked, setIsBidViewBlocked] = useState(false);
    const isSuperAdmin = user?.user_role?.name === 'Super Admin';

    const handleOptionChange = async () => {
        if (new Date(cutOffTime) <= new Date()) {
            try {
                const selectedBid = selectedOption?.[0];
                if (!selectedBid?.id) {
                    Notify('error', 'Please choose a winner');
                    return false;
                }

                const lwRate = selectedBid?.rate || 0;

                if (lwRate > lowestBid) {
                    if (confirm('You are declering highest amount of bid. Are you sure? Do you want to continue with this selection.')) {
                    } else {
                        return false
                    }
                }

                const data = {
                    type: selectedBid?.app_user?.category?.name === 'transporter' ? 'transporter' : 'other',
                    demandId: id,
                    bidId: selectedBid?.id,
                };
                setLoader(true);
                const updateddata = await APIService.post('bid/status/winner', data, true, true);
                setLoader(false);
                if (updateddata.status === 200) {
                    Notify('success', 'Winner declared successfully');
                    // if (data?.type === 'other') {
                    //     navigate('/home/finalisedbids/other');
                    // } else {
                    //     navigate('/home/finalisedbids/transporter');
                    // }
                    setSelectedOption([]);
                    setresetRadio(null);
                    setConfirmModal(false);
                    setDeleteShow(false);
                    getBids();
                }
            } catch (err) {
                setLoader(false);
                setSelectedOption([]);
                setresetRadio(null);
                setConfirmModal(false);
                setDeleteShow(false);
            }
        } else {
            setLoader(false);
            Notify('error', 'Please allow to pass cut off time');
        }
    };

    const handleReset = () => {
        setSelectedOption([]);
        setresetRadio(null);
        setDeleteShow(false);
    };

    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
        } catch (error) { }
    };
    const searchItem = async (value: any) => {
        try {
            if (isBidViewBlocked) {
                return;
            }
            setLoader(true);
            const data = await APIService.getAll(
                `bid/search/${params.id}/${params.type}/bids?order=desc&sort=createdAt&search=${value}`,
                true,
                false,
            );
            setLoader(false);
            setBids(data.data.data || []);
        } catch (err) {
            setLoader(false);
        }
    };

    const debouncedResults = useMemo(() => {
        return debounce(searchItem, 1000);
    }, []);

    const getBids = async () => {
        try {
            let url = `bid/demand/oth/${params.id}`;
            if (params.type === 'transporter') {
                url = `bid/demand/${params.id}`;
            }
            setLoader(true);
            const apiResp = await APIService.getAll(url, true, false);

            setLoader(false);
            if (apiResp) {
                const { data } = apiResp;
                setDemandData(data.data);
                setCutOffTime(data.data.cutOffTime);
                const isBeforeCutoff = data.data?.cutOffTime && new Date(data.data.cutOffTime) > new Date();
                if (!isSuperAdmin && isBeforeCutoff) {
                    setIsBidViewBlocked(true);
                    setBids([]);
                    setBidWinner(false);
                    setActiveDemand(data.data);
                    setId(data.data.id);
                    setDemandType(data.data.bidType);
                    setDemandStatus(data.data.status);
                    return;
                }

                setIsBidViewBlocked(false);
                if (data?.data?.bids?.length) {
                    const { bids } = data.data;
                    const lowestRate = bids.reduce((min, item) => (item.rate < min ? item.rate : min), Infinity);
                    setLowestBid(lowestRate)
                    setDemandData(data.data);
                    const isAllBidRunning = bids.some(item => item.status === 'running');
                    setBidWinner(isAllBidRunning);


                }
                setActiveDemand(data.data);
                setId(data.data.id);
                setDemandType(data.data.bidType);
                setDemandStatus(data.data.status);
                // setBids(data.data.bids);

                const final = data.data.bids.map(e => ({
                    ...e,
                    rating:
                        e?.app_user?.rating_appUsers.reduce((sum, curr) => (sum += curr.rating), 0) /
                        e?.app_user?.rating_appUsers.length,
                }));

                setBids(final);
            }
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getBids();
        return () => {
            if (debouncedResults) {
                debouncedResults.cancel();
            }
        };
    }, []);

    const updateStatus = async (item: any, bidStatus: any, id: any) => {
        try {
            const data = {
                status: bidStatus,
            };
            setLoader(true);
            const { status: statusApi } = await APIService.update('bid/status/onhold', id, data, true, true);
            setLoader(false);
            if (statusApi === 200) {
                Notify('success', 'Bid status updated');
                getBids();
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const demandRolloutMethod = async (demand_id: any) => {
        try {
            const data = {
                demandId: demand_id
            };
            setLoader(true);
            const responseData = await APIService.post('bid/rollout', data, true);
            console.log('responseData=>', responseData)
            setLoader(false);
            if (responseData.status === 200) {
                Notify('success', 'Demand Roll out Successfully');
                getBids();
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const getBidsById = async (id: any) => {
        if (params.type === 'others') {
            const data: any = Bids.filter((data: any) => data.id == id);

            setFormData({
                ['name']: data[0]?.app_user?.name,
                ['phone']: data[0]?.app_user?.phone,
                ['category']: data[0]?.app_user?.category?.name,
                ['email']: data[0]?.app_user?.email,
                ['biddingdate']: data[0]?.createdAt,
                ['amount']: data[0]?.rate,
                ['delivery']: data[0]?.expectedDeliveryDate,
                ['item']: activeDemand.item ? activeDemand.item.name : 'N/A',
                ['city']: data[0]?.app_user?.other_document?.city,
                ['address']: data[0]?.app_user?.other_document?.address,
                ['pincode']: data[0]?.app_user?.other_document?.pincode,
                ['sampleId']: data[0]?.sampleId,
                ['drivingLicenseBack']: data[0]?.drivingLicenseBack,
                ['drivingLicenseFront']: data[0]?.drivingLicenseFront,
                ['vehicleLrNo']: data[0]?.vehicleLrNo,
                ['vehicleNo']: data[0]?.vehicleNo,
            });
            handelModel(true);
        } else {
            const data: any = Bids.filter((data: any) => data.id == id);

            setFormData({
                ['name']: data[0]?.app_user?.name,
                ['phone']: data[0]?.app_user?.phone,
                ['category']: data[0]?.app_user?.category?.name,
                ['email']: data[0]?.app_user?.email,
                ['biddingdate']: data[0]?.createdAt,
                ['amount']: data[0]?.rate,
                ['delivery']: data[0]?.expectedDeliveryDate,
                ['city']: data[0]?.app_user?.document_transporter?.city,
                ['address']: data[0]?.app_user?.document_transporter?.address,
                ['pincode']: data[0]?.app_user?.document_transporter?.pincode,
                ['sampleId']: data[0]?.bids?.sampleId,
                ['drivingLicenseBack']: data[0]?.drivingLicenseBack,
                ['drivingLicenseFront']: data[0]?.drivingLicenseFront,
                ['vehicleLrNo']: data[0]?.vehicleLrNo,
                ['vehicleNo']: data[0]?.vehicleNo,
            });
            handelModel(true);
        }
    };
    const handlewinner = (item: any) => {
        try {
            const arr: any = [];
            arr.push(item);
            const id = item?.id || null;
            setresetRadio(id);
            setSelectedOption(arr);
        } catch (error) { }
    };

    const handleDemandDetail = () => {
        setDemandModel(true);
    };

    // Hide and show other demand details
    const handleOtherDemandDetail = () => {
        setOtherDemandModel(true);
    };

    return (
        <>
            <div className="container dash-container">
                <div className="dash_bread_box">
                    <ul>
                        <li>
                            <NavLink to={`/home/${params.type === 'others' ? 'others' : 'demands'}`}>
                                Bid Listing
                            </NavLink>
                        </li>
                        <li>{params.bread}</li>
                    </ul>
                </div>
                <div className="content_body_cover">
                    {isBidViewBlocked ? (
                        <div className="content_box">
                            <div className="text-center p-4">
                                <h5>Bids can be viewed after cutoff time.</h5>
                                <p className="text-muted mb-3">Only Super Admin can view ongoing bids before cutoff.</p>
                                <NavLink
                                    to={params.type === 'others' ? '/home/others' : '/home/demands'}
                                    className="btn custom_btn border_btn with_icon"
                                >
                                    Back
                                </NavLink>
                            </div>
                        </div>
                    ) : params.type === 'others' ? (
                        <>
                            <div className="table_filter_box_cover">
                                <div className="row">
                                    <div className="col-sm-7">
                                        <div className="table_filter_inner_box">
                                            <div>
                                                <form className="search_filter_box">
                                                    <input
                                                        type="text"
                                                        placeholder={`Search here...`}
                                                        value={search}
                                                        onChange={e => {
                                                            searchItem(e.target.value);
                                                            setSearch(e.target.value);
                                                            setDeleteShow(false);
                                                        }}
                                                    />
                                                    <img
                                                        className="search_icon img-fluid"
                                                        src="assets/images/search_btn.svg"
                                                        alt=""
                                                    />
                                                </form>
                                                <small className="font10">Search By Vendor Name, Bid Id, Amount</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-5">
                                        <div
                                            className="table_add_inner_box delete_box"
                                            style={deleteShow ? { display: 'none' } : { display: 'flex' }}
                                        >
                                            {bidWinner &&
                                                ((user.demandType === 'manual' && demandType == 'manual') ||
                                                    demandType == 'manual') ? (
                                                <>
                                                    {(actionsPermissionValidator(
                                                        '/home/bids/other',
                                                        ActionValues.Add,
                                                    ) ||
                                                        actionsPermissionValidator(
                                                            '/home/bids/other',
                                                            ActionValues.Edit,
                                                        )) && (
                                                            <button
                                                                className="btn custom_btn orange_btn with_icon"
                                                                onClick={() => {
                                                                    setDeleteShow(true);
                                                                    setSelectedOption([]);
                                                                    setresetRadio(null);
                                                                }}
                                                                disabled={
                                                                    new Date(cutOffTime) > new Date() ||
                                                                    demandStatus === 'inactive'
                                                                }
                                                            >
                                                                <img src="assets/images/winner.svg" className="img-fluid" />
                                                                Declare Winner
                                                            </button>
                                                        )}
                                                </>
                                            ) : (
                                                <></>
                                            )}

                                            <NavLink
                                                to={params.type === 'others' ? '/home/others' : '/home/demands'}
                                                className="btn custom_btn border_btn with_icon add_box_delete_btn"
                                                style={{ float: 'right' }}
                                            >
                                                Back
                                            </NavLink>
                                        </div>
                                        {bidWinner ? (
                                            <div
                                                className="table_add_inner_box delete_box"
                                                style={deleteShow ? { display: 'flex' } : { display: 'none' }}
                                            >
                                                <a
                                                    className="btn custom_btn orange_btn with_icon"
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                        selectedOption.length > 0
                                                            ? setConfirmModal(true)
                                                            : Notify('error', 'Please choose a winner');
                                                    }}
                                                >
                                                    Declare
                                                </a>

                                                <a
                                                    href="javascript:void(0)"
                                                    className="btn custom_btn border_btn with_icon add_box_delete_btn"
                                                    style={{ float: 'right' }}
                                                    onClick={() => {
                                                        setDeleteShow(false);
                                                        handleReset();
                                                    }}
                                                >
                                                    Cancel
                                                </a>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="table_box_cover table_responsive_box" style={{ minHeight: '300px' }}>
                                <table className="dataTable display manage_Penalty_table" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th
                                                className="no-sort all_check_box check_box option_box sorting_disabled sorting_asc"
                                                style={
                                                    deleteShow
                                                        ? { display: 'table-cell', width: '13px' }
                                                        : { display: 'none', width: '13px' }
                                                }
                                            ></th>
                                            {[
                                                'Demand Id',
                                                ' Bid Id',
                                                'Vendor Name',
                                                'Vendor Rating',
                                                'Category Name',
                                                'Bidding Date & Time',
                                                'Amount (Rs.)',
                                                'Delivery Date & Time',
                                                'Demand Created Date',
                                            ].map((i: any, j: number) => {
                                                return <th key={j}>{i}</th>;
                                            })}

                                            <th className="no-sort">Status</th>

                                            <th className="no-sort">Action </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Bids.length > 0 &&
                                            Bids.map((item: any, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td
                                                            className="check_box option_box sorting_1"
                                                            style={
                                                                deleteShow
                                                                    ? { display: 'table-cell' }
                                                                    : { display: 'none' }
                                                            }
                                                        >
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id={`flexRadioDefault${index + 1}`}
                                                                    disabled={
                                                                        item?.status == 'cancelled' ||
                                                                            item?.status == 'notSelected' ||
                                                                            item?.status == 'onHold' ||
                                                                            item?.status == 'withdraw'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    checked={item?.id == resetRadio}
                                                                    onChange={() => {
                                                                        handlewinner(item);
                                                                    }}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <a
                                                                style={{
                                                                    textDecoration: 'underline',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={handleOtherDemandDetail}
                                                            >
                                                                {item?.demandOthersId}
                                                            </a>
                                                        </td>

                                                        <td>{item?.id}</td>
                                                        {/* <td>{item?.app_user?.name}</td> */}
                                                        <td>{TextTruncate(item?.app_user?.name, 15, true)}</td>

                                                        <td>
                                                            <ReactStars
                                                                count={5}
                                                                value={item.rating}
                                                                size={19}
                                                                isHalf={true}
                                                                emptyIcon={
                                                                    <i
                                                                        className="fa fa-star"
                                                                        style={{ color: 'green' }}
                                                                    ></i>
                                                                }
                                                                halfIcon={
                                                                    <i
                                                                        className="fa fa-star-half-alt"
                                                                        style={{ color: 'white' }}
                                                                    ></i>
                                                                }
                                                                fullIcon={
                                                                    <i
                                                                        className="fa fa-star"
                                                                        style={{ color: 'white' }}
                                                                    ></i>
                                                                }
                                                                activeColor="#FFA800"
                                                                edit={false}
                                                            />
                                                        </td>

                                                        <td>{item?.app_user?.category?.name}</td>

                                                        <td>
                                                            {DateFormatPicker(item?.createdAt, 'DD-MMM-YYYY hh:mm A')}
                                                        </td>

                                                        <td>
                                                            {
                                                                (item?.rate == lowestBid) ?
                                                                    <span className="text-center text-success">
                                                                        {item?.rate}
                                                                    </span>
                                                                    :
                                                                    item?.rate
                                                            }</td>

                                                        <td>
                                                            {DateFormatPicker(
                                                                item?.expectedDeliveryDate,
                                                                'DD-MMM-YYYY hh:mm A',
                                                            )}
                                                        </td>
                                                        <td>
                                                            {DateFormatPicker(
                                                                demandData?.createdAt,
                                                                'DD-MMM-YYYY hh:mm A',
                                                            )}
                                                        </td>

                                                        <td>
                                                            {item.status !== 'withdraw' ? (
                                                                <>
                                                                    {item?.status !== 'notSelected' ? (
                                                                        <>
                                                                            {item.status === 'winner' ? (
                                                                                <span className="text-center text-success">
                                                                                    Winner
                                                                                </span>
                                                                            ) : item.status === 'pending' ? (
                                                                                <span className="text-center text-danger">
                                                                                    Pending
                                                                                </span>
                                                                            ) : item.status === 'cancelled' ? (
                                                                                <span className="text-center text-danger">
                                                                                    Cancelled
                                                                                </span>
                                                                            ) : (
                                                                                <>
                                                                                    {actionsPermissionValidator(
                                                                                        '/home/bids/other',
                                                                                        ActionValues.Edit,
                                                                                    ) ||
                                                                                        actionsPermissionValidator(
                                                                                            '/home/bids/other',
                                                                                            ActionValues.Add,
                                                                                        ) ? (
                                                                                        <div
                                                                                            className={
                                                                                                item.status ===
                                                                                                    'running'
                                                                                                    ? 'dropdown dropdown_status_box '
                                                                                                    : 'dropdown dropdown_status_box hold_status_box'
                                                                                            }
                                                                                        >
                                                                                            <button
                                                                                                className="btn btn-secondary dropdown-toggle capitalize"
                                                                                                type="button"
                                                                                                id="dropdownMenuButton1"
                                                                                                data-bs-toggle="dropdown"
                                                                                                aria-expanded="false"
                                                                                            >
                                                                                                {item?.status}
                                                                                            </button>
                                                                                            <ul
                                                                                                className="dropdown-menu"
                                                                                                aria-labelledby="dropdownMenuButton1"
                                                                                            >
                                                                                                <li>
                                                                                                    <a
                                                                                                        className={
                                                                                                            item.status ===
                                                                                                                'running'
                                                                                                                ? 'dropdown-item active'
                                                                                                                : 'dropdown-item'
                                                                                                        }
                                                                                                        href="javascript:void(0)"
                                                                                                        onClick={() => {
                                                                                                            updateStatus(
                                                                                                                item,
                                                                                                                'running',
                                                                                                                item.id,
                                                                                                            );
                                                                                                        }}
                                                                                                    >
                                                                                                        Running
                                                                                                    </a>
                                                                                                </li>
                                                                                                <li>
                                                                                                    <a
                                                                                                        className={
                                                                                                            item.status ===
                                                                                                                'onHold'
                                                                                                                ? 'dropdown-item active'
                                                                                                                : 'dropdown-item '
                                                                                                        }
                                                                                                        href="javascript:void(0)"
                                                                                                        onClick={() => {
                                                                                                            updateStatus(
                                                                                                                item,
                                                                                                                'onHold',
                                                                                                                item.id,
                                                                                                            );
                                                                                                        }}
                                                                                                    >
                                                                                                        On hold
                                                                                                    </a>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div
                                                                                            className={
                                                                                                'button_disabled'
                                                                                            }
                                                                                        >
                                                                                            <button
                                                                                                className="capitalize text-center"
                                                                                                type="button"
                                                                                                disabled
                                                                                            >
                                                                                                {item?.status}
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                    {/* <div
                                                                                        className={
                                                                                            item.status === 'running'
                                                                                                ? 'dropdown dropdown_status_box '
                                                                                                : 'dropdown dropdown_status_box hold_status_box'
                                                                                        }
                                                                                    >
                                                                                        <button
                                                                                            className="btn btn-secondary dropdown-toggle capitalize"
                                                                                            type="button"
                                                                                            id="dropdownMenuButton1"
                                                                                            data-bs-toggle="dropdown"
                                                                                            aria-expanded="false"
                                                                                        >
                                                                                            {item?.status}
                                                                                        </button>
                                                                                        <ul
                                                                                            className="dropdown-menu"
                                                                                            aria-labelledby="dropdownMenuButton1"
                                                                                        >
                                                                                            <li>
                                                                                                <a
                                                                                                    className={
                                                                                                        item.status ===
                                                                                                        'running'
                                                                                                            ? 'dropdown-item active'
                                                                                                            : 'dropdown-item'
                                                                                                    }
                                                                                                    href="javascript:void(0)"
                                                                                                    onClick={() => {
                                                                                                        updateStatus(
                                                                                                            item,
                                                                                                            'running',
                                                                                                            item.id,
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    Running
                                                                                                </a>
                                                                                            </li>
                                                                                            <li>
                                                                                                <a
                                                                                                    className={
                                                                                                        item.status ===
                                                                                                        'onHold'
                                                                                                            ? 'dropdown-item active'
                                                                                                            : 'dropdown-item '
                                                                                                    }
                                                                                                    href="javascript:void(0)"
                                                                                                    onClick={() => {
                                                                                                        updateStatus(
                                                                                                            item,
                                                                                                            'onHold',
                                                                                                            item.id,
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    On hold
                                                                                                </a>
                                                                                            </li>
                                                                                        </ul>
                                                                                    </div> */}
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <span className="text-center text-danger">
                                                                            Not selected
                                                                        </span>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <span className="text-center text-secondary">
                                                                    Withdraw
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td className="alignmiddle">
                                                            <button
                                                                className="btn bidsblue_btn custom_btn"
                                                                onClick={() => {
                                                                    getBidsById(item.id);
                                                                }}
                                                            >
                                                                View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        {Bids.length === 0 ? (
                                            <tr>
                                                <td colSpan={8} className="text-center textTransformNone">
                                                    No data found
                                                </td>
                                            </tr>
                                        ) : (
                                            ''
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="table_filter_box_cover">
                                <div className="row">
                                    <div className="col-sm-7">
                                        <div className="table_filter_inner_box">
                                            <div>
                                                <form className="search_filter_box">
                                                    <input
                                                        type="text"
                                                        placeholder={`Search here...`}
                                                        value={search}
                                                        onChange={e => {
                                                            searchItem(e.target.value);
                                                            setSearch(e.target.value);
                                                            setDeleteShow(false);
                                                        }}
                                                    />
                                                    <img
                                                        className="search_icon img-fluid"
                                                        src="assets/images/search_btn.svg"
                                                        alt=""
                                                    />
                                                </form>
                                                <small className="font10">
                                                    Search By Transporter Name, Bid Id, Amount
                                                </small>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-5">
                                        <div
                                            className="table_add_inner_box delete_box"
                                            style={deleteShow ? { display: 'none' } : { display: 'flex' }}
                                        >
                                            {bidWinner &&
                                                ((user.demandType === 'manual' && demandType == 'manual') ||
                                                    demandType == 'manual') ? (
                                                <>
                                                    {(actionsPermissionValidator(
                                                        '/home/bids/transporter',
                                                        ActionValues.Add,
                                                    ) ||
                                                        actionsPermissionValidator(
                                                            '/home/bids/transporter',
                                                            ActionValues.Edit,
                                                        )) && (
                                                            <button
                                                                className="btn custom_btn orange_btn with_icon"
                                                                onClick={() => {
                                                                    setDeleteShow(true);
                                                                    setSelectedOption([]);
                                                                    setresetRadio(null);
                                                                }}
                                                                disabled={
                                                                    new Date(cutOffTime) > new Date() ||
                                                                    demandStatus === 'inactive'
                                                                }
                                                            >
                                                                <img src="assets/images/winner.svg" className="img-fluid" />
                                                                Declare Winner
                                                            </button>
                                                        )}
                                                </>
                                            ) : (
                                                ''
                                            )}

                                            <NavLink
                                                to={params.type === 'others' ? '/home/others' : '/home/demands'}
                                                className="btn custom_btn border_btn with_icon add_box_delete_btn"
                                                style={{ float: 'right' }}
                                            >
                                                Back
                                            </NavLink>
                                        </div>
                                        {bidWinner ? (
                                            <div
                                                className="table_add_inner_box delete_box"
                                                style={deleteShow ? { display: 'flex' } : { display: 'none' }}
                                            >
                                                <a
                                                    className="btn custom_btn orange_btn with_icon"
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                        selectedOption.length > 0
                                                            ? setConfirmModal(true)
                                                            : Notify('error', 'Please choose a winner');
                                                    }}
                                                >
                                                    Declare
                                                </a>

                                                <a
                                                    href="javascript:void(0)"
                                                    className="btn custom_btn border_btn with_icon add_box_delete_btn"
                                                    style={{ float: 'right' }}
                                                    onClick={() => {
                                                        setDeleteShow(false);
                                                        handleReset();
                                                    }}
                                                >
                                                    Cancel
                                                </a>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="table_box_cover table_responsive_box" style={{ minHeight: '300px' }}>
                                <table className="dataTable display manage_Penalty_table" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th
                                                className="no-sort all_check_box check_box option_box sorting_disabled sorting_asc"
                                                style={
                                                    deleteShow
                                                        ? { display: 'table-cell', width: '13px' }
                                                        : { display: 'none', width: '13px' }
                                                }
                                            ></th>
                                            {[
                                                'Demand Id',
                                                'Demand Created Date',
                                                'Bid Id',
                                                'Transporter Name',
                                                'Transporter Rating',
                                                'Bidding Date & Time',
                                                'Amount (Rs.)',
                                                'Delivery Date & Time',
                                            ].map((i: any, j: number) => {
                                                return <th key={j}>{i}</th>;
                                            })}

                                            <th className="no-sort">Status</th>

                                            <th className="no-sort">Action </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Bids.length > 0 &&
                                            Bids.map((item: any, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td
                                                            className="check_box option_box sorting_1"
                                                            style={
                                                                deleteShow
                                                                    ? { display: 'table-cell' }
                                                                    : { display: 'none' }
                                                            }
                                                        >
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id={`flexRadioDefault${index + 1}`}
                                                                    disabled={
                                                                        item?.status == 'cancelled' ||
                                                                            item?.status == 'notSelected' ||
                                                                            item?.status == 'onHold' ||
                                                                            item?.status == 'withdraw'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    checked={item?.id == resetRadio}
                                                                    onChange={() => {
                                                                        handlewinner(item);
                                                                    }}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <a
                                                                style={{
                                                                    textDecoration: 'underline',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={handleDemandDetail}
                                                            >
                                                                {item?.demandId}{' '}
                                                            </a>
                                                        </td>
                                                        <td>
                                                            {DateFormatPicker(
                                                                demandData?.createdAt,
                                                                'DD-MMM-YYYY hh:mm A',
                                                            )}
                                                        </td>
                                                        <td>{item?.id}</td>
                                                        <td title={item?.app_user?.companyname}>{TextTruncate(item?.app_user?.companyname, 15, true)}</td>

                                                        <td>
                                                            <ReactStars
                                                                count={5}
                                                                value={item?.rating}
                                                                size={19}
                                                                isHalf={true}
                                                                emptyIcon={
                                                                    <i
                                                                        className="fa fa-star"
                                                                        style={{ color: 'green' }}
                                                                    ></i>
                                                                }
                                                                halfIcon={
                                                                    <i
                                                                        className="fa fa-star-half-alt"
                                                                        style={{ color: 'white' }}
                                                                    ></i>
                                                                }
                                                                fullIcon={
                                                                    <i
                                                                        className="fa fa-star"
                                                                        style={{ color: 'white' }}
                                                                    ></i>
                                                                }
                                                                activeColor="#FFA800"
                                                                edit={false}
                                                            />
                                                        </td>

                                                        <td>
                                                            {DateFormatPicker(item?.createdAt, 'DD-MMM-YYYY hh:mm A')}
                                                        </td>

                                                        <td>
                                                            {
                                                                (item?.rate == lowestBid) ?
                                                                    <span className="text-center text-success">
                                                                        {item?.rate}
                                                                    </span>
                                                                    :
                                                                    item?.rate
                                                            }</td>

                                                        <td>
                                                            {DateFormatPicker(
                                                                item?.expectedDeliveryDate,
                                                                'DD-MMM-YYYY hh:mm A',
                                                            )}
                                                        </td>

                                                        <td>
                                                            {item.status !== 'withdraw' ? (
                                                                <>
                                                                    {item?.status !== 'notSelected' ? (
                                                                        <>
                                                                            {item.status === 'winner' ? (
                                                                                <span className="text-center text-success">
                                                                                    Winner
                                                                                </span>
                                                                            ) : item.status === 'pending' ? (
                                                                                <span className="text-center text-danger">
                                                                                    Pending
                                                                                </span>
                                                                            ) : item.status === 'cancelled' ? (
                                                                                <span className="text-center text-danger">
                                                                                    Cancelled
                                                                                </span>
                                                                            ) : (
                                                                                <>
                                                                                    {actionsPermissionValidator(
                                                                                        '/home/bids/transporter',
                                                                                        ActionValues.Edit,
                                                                                    ) ||
                                                                                        actionsPermissionValidator(
                                                                                            '/home/bids/transporter',
                                                                                            ActionValues.Add,
                                                                                        ) ? (
                                                                                        <div
                                                                                            className={
                                                                                                item.status ===
                                                                                                    'running'
                                                                                                    ? 'dropdown dropdown_status_box '
                                                                                                    : 'dropdown dropdown_status_box hold_status_box'
                                                                                            }
                                                                                        >
                                                                                            <button
                                                                                                className="btn btn-secondary dropdown-toggle capitalize"
                                                                                                type="button"
                                                                                                id="dropdownMenuButton1"
                                                                                                data-bs-toggle="dropdown"
                                                                                                aria-expanded="false"
                                                                                            >
                                                                                                {item?.status}
                                                                                            </button>
                                                                                            <ul
                                                                                                className="dropdown-menu"
                                                                                                aria-labelledby="dropdownMenuButton1"
                                                                                            >
                                                                                                <li>
                                                                                                    <a
                                                                                                        className={
                                                                                                            item.status ===
                                                                                                                'running'
                                                                                                                ? 'dropdown-item active'
                                                                                                                : 'dropdown-item'
                                                                                                        }
                                                                                                        href="javascript:void(0)"
                                                                                                        onClick={() => {
                                                                                                            updateStatus(
                                                                                                                item,
                                                                                                                'running',
                                                                                                                item.id,
                                                                                                            );
                                                                                                        }}
                                                                                                    >
                                                                                                        Running
                                                                                                    </a>
                                                                                                </li>
                                                                                                <li>
                                                                                                    <a
                                                                                                        className={
                                                                                                            item.status ===
                                                                                                                'onHold'
                                                                                                                ? 'dropdown-item active'
                                                                                                                : 'dropdown-item '
                                                                                                        }
                                                                                                        href="javascript:void(0)"
                                                                                                        onClick={() => {
                                                                                                            updateStatus(
                                                                                                                item,
                                                                                                                'onHold',
                                                                                                                item.id,
                                                                                                            );
                                                                                                        }}
                                                                                                    >
                                                                                                        On hold
                                                                                                    </a>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div
                                                                                            className={
                                                                                                'button_disabled'
                                                                                            }
                                                                                        >
                                                                                            <button
                                                                                                className="capitalize text-center"
                                                                                                type="button"
                                                                                                disabled
                                                                                            >
                                                                                                {item?.status}
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <span className="text-center text-danger">
                                                                            Not selected
                                                                        </span>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <span className="text-center text-secondary">
                                                                    Withdraw
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td className="alignmiddle">

                                                            <button
                                                                className="btn bidsblue_btn custom_btn"
                                                                onClick={() => {
                                                                    getBidsById(item.id);
                                                                }}
                                                            >
                                                                View
                                                            </button>
                                                            {item?.status == 'pending' &&
                                                                <button
                                                                    onClick={() => {
                                                                        demandRolloutMethod(item?.demandId)
                                                                    }}
                                                                    style={{ marginLeft: '5px' }}

                                                                    className="btn rollout_btn custom_btn"
                                                                >
                                                                    Roll out
                                                                </button>
                                                            }

                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        {Bids.length === 0 ? (
                                            <tr>
                                                <td colSpan={8} className="text-center textTransformNone">
                                                    No data found
                                                </td>
                                            </tr>
                                        ) : (
                                            ''
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
                {demandModel && (
                    <ViewModel
                        data={demandData}
                        showModel={true}
                        demandModelCallback={() => {
                            setDemandModel(false);
                        }}
                    />
                )}

                {otherDemandModel && (
                    <OtherDemandView
                        data={demandData}
                        showModel={true}
                        otherDemandModelCallback={() => {
                            setOtherDemandModel(false);
                        }}
                    />
                )}
                {confirmModal && (
                    <Modal
                        show={true}
                        onHide={() => {
                            setSelectedOption([]);
                            setresetRadio(null);
                            setConfirmModal(false);
                            setDeleteShow(false);
                        }}
                        backdrop="static"
                        aria-labelledby="contained-modal-title-vcenter"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">Declare Winner</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="model">
                                <div className="text_box">
                                    <h3>
                                        Are sure you want to declare {selectedOption?.[0]?.app_user?.name} as bid
                                        winner?
                                    </h3>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                className="btn dark_btn custom_btn"
                                style={{ backgroundColor: '#D55E0A', color: 'white' }}
                                onClick={() => {
                                    handleOptionChange();
                                }}
                            >
                                Declare
                            </Button>
                            <Button
                                variant="default"
                                className="btn custom_btn border_btn with_icon"
                                onClick={() => {
                                    setSelectedOption([]);
                                    setresetRadio(null);
                                    setConfirmModal(false);
                                    setDeleteShow(false);
                                }}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
                {showHideModel && (
                    <Modal
                        scrollable={true}
                        show={true}
                        onHide={() => handelModel(false)}
                        backdrop="static"
                        size="lg"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Bid Information</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="detail_modal_cover">
                                <div className="details_box_cover">
                                    <div className="container">
                                        <h3>User Details</h3>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <ul className="detail_list">
                                                    <li>
                                                        <span className="sub_box">Full Name</span>
                                                        <span className="main_box">{formData?.name}</span>
                                                    </li>
                                                    <li>
                                                        <span className="sub_box">Mobile No.</span>
                                                        <span className="main_box">{formData?.phone}</span>
                                                    </li>
                                                    <li>
                                                        <span className="sub_box">City</span>
                                                        <span className="main_box">{formData?.city}</span>
                                                    </li>
                                                    <li>
                                                        <span className="sub_box">Pincode</span>
                                                        <span className="main_box">{formData?.pincode}</span>
                                                    </li>
                                                    {formData?.vehicleNo && (
                                                        <li>
                                                            <span className="sub_box">Vehicle No.</span>
                                                            <span className="main_box">{formData?.vehicleNo}</span>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                            <div className="col-sm-6">
                                                <ul className="detail_list">
                                                    <li>
                                                        <span className="sub_box">Email</span>
                                                        <span className="main_box">{formData?.email || 'N/A'}</span>
                                                    </li>
                                                    <li>
                                                        <span className="sub_box">Category</span>
                                                        <span className="main_box">{formData?.category}</span>
                                                    </li>
                                                    <li>
                                                        <span className="sub_box">Address</span>
                                                        <span className="main_box">{formData?.address}</span>
                                                    </li>

                                                    {formData?.sampleId && (
                                                        <li>
                                                            <span className="sub_box">Attachment</span>
                                                            <a
                                                                target="_blank"
                                                                className="text-primary"
                                                                rel="noreferrer"
                                                                href={`${process.env.REACT_APP_API_BASE}${formData?.sampleId}`}
                                                            >
                                                                <u>View</u>
                                                            </a>
                                                        </li>
                                                    )}
                                                    {formData?.drivingLicenseBack && formData?.drivingLicenseFront && (
                                                        <li>
                                                            <span className="sub_box">DrivingLicense</span>
                                                            <a
                                                                target="_blank"
                                                                className="text-primary"
                                                                rel="noreferrer"
                                                                href={`${process.env.REACT_APP_API_BASE}/bids/${formData?.drivingLicenseBack}`}
                                                            >
                                                                <u>View</u>
                                                            </a>
                                                            <a
                                                                target="_blank"
                                                                className="text-primary"
                                                                style={{ marginLeft: '30px' }}
                                                                rel="noreferrer"
                                                                href={`${process.env.REACT_APP_API_BASE}/bids/${formData?.drivingLicenseFront}`}
                                                            >
                                                                <u>View</u>
                                                            </a>
                                                        </li>
                                                    )}
                                                    {formData?.vehicleLrNo && (
                                                        <li>
                                                            <span className="sub_box">LR No.</span>
                                                            <span className="main_box">{formData?.vehicleLrNo}</span>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                        <hr></hr>
                                        {params.type === 'others' ? (
                                            <>
                                                <h3>Item Details</h3>
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <span className="sub_box">Item Name</span>
                                                                <span className="main_box">{formData?.item}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <hr />
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {/* <hr/> */}
                                        <h3>Bid Details</h3>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <ul className="detail_list">
                                                    <li>
                                                        <span className="sub_box">Bidding Date</span>

                                                        <span className="main_box">
                                                            {DateFormatPicker(formData?.biddingdate, 'DD-MMM-YYYY')}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <span className="sub_box">
                                                            Amount <br></br>
                                                            <small className="size">
                                                                (Per {activeDemand?.itemUnit})
                                                            </small>
                                                        </span>
                                                        <span className="main_box">{formData?.amount} Rs.</span>
                                                    </li>
                                                    <li>
                                                        <span className="sub_box">Delivery Time</span>
                                                        <span className="main_box">
                                                            {DateFormatPicker(formData?.delivery, 'hh:mm A')}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="col-sm-6">
                                                <ul className="detail_list">
                                                    <li>
                                                        <span className="sub_box">Bidding Time</span>
                                                        <span className="main_box">
                                                            {DateFormatPicker(formData?.biddingdate, 'hh:mm A')}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <span className="sub_box">Delivery Date</span>
                                                        <span className="main_box">
                                                            {DateFormatPicker(formData?.delivery, 'DD-MMM-YYYY')}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                )}
            </div>
        </>
    );
}
